define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var validationUtil = require('util/validation.util');
    const dom = require('util/dom.util');
    const $ = require('j');
    const dateUtil = require('util/date.util');
    const i18n = require('i18n');
    const user = require('user');
    const util = require('utils');
    const config = require('config');

    Object.defineProperty(validationUtil, 'defaultRules', {
        get: function() {
            const lang = user.get('lang');
            const regulation = config.get('regulation');

            if (!this._cachedDefaultRules || this._cachedDefaultRulesLang !== lang + regulation) {
                // noinspection RegExpRedundantEscape
                var result = {
                    required: {
                        priority: 0,
                        message: i18n.t('playtech.mobile.system.tooltip.required')
                    },
                    email: {
                        priority: 100,
                        regexp: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
                        message: i18n.t('playtech.mobile.system.tooltip.email')
                    },
                    number: {
                        priority: 100,
                        regexp: /^$|^\-?((\d+\.?$)|(\.\d+$)|(\d+\.\d+$))/,
                        message: i18n.t('playtech.mobile.system.tooltip.number')
                    },
                    amount: {
                        priority: 100,
                        // any digit except 0 + 0-many digits OR
                        // any digit except 0 + 0-many digits + (dot AND 1 or 2 digits) OR
                        // zero AND dot AND 1 or 2 digits
                        regexp: /^[1-9]\d*$|^[1-9]\d*(?:\.\d{1,2})?$|^0(?:\.\d{1,2}){1}$/,
                        message: i18n.t('playtech.mobile.system.tooltip.amount')
                    },
                    length: {
                        priority: 200,
                        min: 1,
                        max: 10
                    },
                    range: {
                        priority: 300,
                        min: 0,
                        max: 0
                    },
                    exclusion: {
                        priority: 300,
                    },
                    dateRange: {
                        priority: 300,
                        min: 0,
                        max: 0
                    },
                    regexp: {
                        priority: 500,
                        regexp: /^\w+&/,
                        message: i18n.t('playtech.mobile.system.tooltip.regexp')
                    },
                    fn: {
                        priority: 1000,
                        /**
                         * @abstract
                         */
                        fn: function($inputs, cfg, form, dfd) { // eslint-disable-line
                            return true;
                        }
                    },
                    ajax: {
                        priority: 2000,
                        fn: function($inputs, cfg, form, dfd) {
                            dfd.resolve();
                            return dfd;
                        }
                    },
                    // TotalCasino changes
                    unlimited : {
                        message: i18n.t('playtech.mobile.system.user.tooltip.unlimited.fn')
                    }
                    // TotalCasino changes
                };

                // Dynamic translation
                Object.defineProperties(result.length, {
                    'defaultMessage': {
                        configurable: false,
                        enumerable: false,
                        writable: true,
                        value: i18n.t('playtech.mobile.system.tooltip.length')
                    },
                    'simpleMessage': {
                        configurable: false,
                        enumerable: false,
                        writable: true,
                        value: i18n.t('playtech.mobile.system.tooltip.lengthSimple')
                    },
                    'message': {
                        configurable: false,
                        enumerable: true,
                        get: function() {
                            var message = this.min === this.max ? this.simpleMessage : this.defaultMessage;
                            return util.string.format(message, this.min, this.max);
                        },
                        set: function(value) {
                            this.simpleMessage = value;
                            this.defaultMessage = value;
                        }
                    }
                });
                Object.defineProperties(result.range, {
                    'defaultMessage': {
                        configurable: false,
                        enumerable: false,
                        writable: true,
                        value: i18n.t('playtech.mobile.system.tooltip.range')
                    },
                    'message': {
                        configurable: false,
                        enumerable: true,
                        get: function() {
                            return util.string.format(this.defaultMessage, this.min, this.max);
                        },
                        set: function(value) {
                            this.defaultMessage = value;
                        }
                    }
                });

                this._cachedDefaultRules = result;
                this._cachedDefaultRulesLang = lang + regulation;
            }

            return this._cachedDefaultRules;
        }
    });

    module.exports = _.extend(validationUtil, {
        validateDomField: function($field, options) {
            if (!options || !options.validationConfig) {
                return $.Deferred().reject();
            }

            var inputs = ['input', 'select', 'textarea'];
            var selector = inputs.reduce(function(memo, input) {
                return memo.concat(
                    input + ':not([disabled])',
                    input + '.progress:disabled'
                );
            }, []).join(', ');
            var validationType = $field[0].dataset.validationType || '';
            var $inputs = $($field.find(selector).filter(function(el) {
                return !el.classList.contains('no-validate');
            }));

            if (!$inputs.length) {
                return $.Deferred().resolve();
            }

            $inputs.sort((a, b) => {
                const getOrder = (input) => {
                    switch (input.dataset.datePart) {
                        case 'day': return 1;
                        case 'month': return 2;
                        case 'year': return 3;
                        default: return 0;
                    }
                };

                return getOrder(a) - getOrder(b);
            });

            var values = $inputs.map(item => {
                let value = dom.getInputValidationValue(item);
                if (item.classList.contains('registration-custom-mask-remove')) {
                    value = value.replace(/\s/g, '');
                }
                return value;
            });

            return this._validateField(_.extend({}, options, {
                values: values,
                $inputs: $inputs,
                validationType: validationType,
                validationConfig: options.validationConfig
            }));
        },

        // TotalCasino changes
        methods: _.extend({}, validationUtil.methods, {
            required: function(options) {
                var iterator = options.$inputs && options.$inputs[0] && options.$inputs[0].type === 'radio'
                    ? 'some'
                    : 'every';

                // TotalCasino changes
                if (options.values.includes('unlimited')) {
                    return true;
                }
                // TotalCasino changes

                return options.values[iterator](function(value) {
                    return _.isBoolean(value)
                        ? value
                        : value.toString().trim() !== '' && value !== null;
                });
            },
            dateRange: function(options) {
                // TotalCasino changes
                if (options.values.includes('unlimited')) {
                    return true;
                }
                // TotalCasino changes

                const dateStr = new Date(options.values.reverse().join('-'));
                const minDateToUnix = dateUtil.parseStringDateToUnixFormat(options.config.min);
                const maxDateToUnix = dateUtil.parseStringDateToUnixFormat(options.config.max);
                const minFullDate = dateUtil.getStartOfTheDay(new Date(minDateToUnix));
                const maxFullDate = dateUtil.getEndOfTheDay(new Date(maxDateToUnix));

                if (options.values.includes('')) {
                    const fieldType = options.config.fieldType === 'dateOfBirthInner' ? 'dateOfBirth' : options.config.fieldType;

                    options.config.message = `playtech.mobile.system.user.tooltip.${fieldType}.required`;
                    return false;
                }

                if (dateStr < minFullDate) {
                    options.config.message = options.config?.dateRangeMinMessage || 'playtech.mobile.system.user.tooltip.datePicker.range';
                    return false;
                }

                if (dateStr > maxFullDate) {
                    options.config.message = options.config?.dateRangeMaxMessage || 'playtech.mobile.system.user.tooltip.datePicker.range';
                    return false;
                }

                return true;
            },

            // TotalCasino changes
            unlimited: function(options) {
                var unlimitedCount = options.values.filter(value => value === 'unlimited').length;

                return !(unlimitedCount > 0 && unlimitedCount < 3);
            }
        })
    });
});
